// Product Collections
const ProdCollections = {
    s1: {
        tops: {
            title: 'Augustinus Bader The Eyebrow and Lash Enhancing Serum',
            handle: 'augustinus-bader-the-eyebrow-and-lash-enhancing-serum',
        },
        bottoms: {
            title: 'Wellbel Glamlab',
            handle: 'wellbel-glamlab',
        }
    },
    s2: {  
        tops: {
            title: 'Wein Products Personal Ionic Air Purifier',
            handle: 'wein-products-wein-air-supply®-rechargeable-as-300r-personal-ionic-air-purifier',
        },
        bottoms: {
            title: 'SOS ESSENTIALS SOS ONCARE Beverage 250ml',
            handle: 'sos-essentials-sos-oncare-beverage-250ml',
        }
    }
};

// Flag to track whether fetchCartItems has already been called
let cartItemsFetched = false;

// Function to handle changes to the cart drawer element
function handleCartDrawerMutation(mutationsList) {
    const form1Div = document.getElementById("form1");
    const form2Div = document.getElementById("form2");

    for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            // Check if the cart drawer is open
            if (mutation.target.classList.contains('drawer--is-open')) {
                // Check if both form1 and form2 are empty of form elements and prevent duplicate fetch calls
                if (!cartItemsFetched && form1Div.querySelector("form") === null && form2Div.querySelector("form") === null) {
                    fetchCartItems();
                    cartItemsFetched = true; // Set flag to true to prevent multiple calls
                }
            } else {
                // Reset the flag when the cart drawer is closed
                cartItemsFetched = false;
            }
        }
    }
}

// Initialize the MutationObserver for the cart-drawer
const cartDrawerObserver = new MutationObserver(handleCartDrawerMutation);

// Get the cart-drawer element
const cartDrawer = document.getElementById('CartDrawer');

// Start observing the cart-drawer element for attribute changes
if (cartDrawer) {
    cartDrawerObserver.observe(cartDrawer, { attributes: true });
}

// Function to send a message to Slack
function sendCartMessageToSlack() {
    var slackWebhookUrl = ""; // Add your Slack webhook URL here
    var payload = {
        text: "Item Added From Best Sellers we Recommend"
    };

    fetch(slackWebhookUrl, {
        method: "POST",
        body: JSON.stringify(payload)
    })
    .then(function(response) {
        if (!response.ok) {
            throw new Error("Failed to send message to Slack");
        }
    })
    .catch(function(error) {
        console.error("Error:", error);
    });
}

// Function to create an Add to Cart form
function createAddToCartForm(elementId, product) {
    var cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var addToCartForm = document.getElementById(elementId);

    if (!addToCartForm) {
        console.error("Element with ID '" + elementId + "' not found.");
        return;
    }

    // Create the form element
    var form = document.createElement('form');
    form.className = 'form fromSelector';
    form.setAttribute('data-type', 'add-to-cart-form');

    var ImgContainer = document.createElement('a');
    ImgContainer.href = product.url;
    ImgContainer.className = 'bs__image-container';
    ImgContainer.style.overflow = 'hidden';
    ImgContainer.style.height = '90px';
    ImgContainer.style.width = '127px';

    var imageTag = document.createElement('img');
    imageTag.src = product.featured_image;
    imageTag.alt = product.title;
    imageTag.style.objectFit = 'cover';
    imageTag.style.height = '100%';
    imageTag.style.width = '100%';
    imageTag.style.position = 'relative';
    ImgContainer.appendChild(imageTag);
    form.appendChild(ImgContainer);

    if (product && product.variants && product.variants.length > 0) {
        var productIdInput = document.createElement('input');
        productIdInput.type = 'hidden';
        productIdInput.name = 'id';
        productIdInput.value = product.variants[0].id;
        form.appendChild(productIdInput);

        var quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.id = 'quantity';
        quantityInput.name = 'quantity';
        quantityInput.value = '1';
        form.appendChild(quantityInput);

        var infoContainer = document.createElement('div');
        infoContainer.className = 'bs__infoContainer';
        infoContainer.style.display = 'flex';
        infoContainer.style.flexDirection = 'column';
        infoContainer.style.gap = '0.91rem';
        infoContainer.style.fontSize = '0.87rem';

        var name = document.createElement('a');
        name.href = product.url;
        name.style.color = 'black';
        name.innerText = product.title;
        name.style.fontSize = '1rem';
        // name.style.fontWeight = '550';
        name.style.display = '-webkit-box';
        name.style.webkitBoxOrient = 'vertical';    
        name.style.overflow = 'hidden';             
        name.style.textOverflow = 'ellipsis';        
        name.style.webkitLineClamp = '2';          
        name.style.maxWidth = '300px';               
        name.style.lineHeight = '1.5'; 
        infoContainer.appendChild(name);

       var price = document.createElement('div');
        price.classList.add('ProductMeta__Price');
        var productPriceInCents = product.price;
        var currencyCode = window.Shopify.currency.active;
        var userLocale = navigator.language || 'en-US';
        var formattedPrice = formatMoney(productPriceInCents, currencyCode, userLocale);
        var textNode = document.createTextNode(formattedPrice);
        price.appendChild(textNode);
        infoContainer.appendChild(price);

        var containerBottom = document.createElement('div');
        containerBottom.style.display = 'flex';
        containerBottom.style.gap = '0.5rem';

        var sizeContainer = document.createElement('div');
        sizeContainer.style.display = 'flex';
        sizeContainer.style.alignItems = 'center';
        sizeContainer.style.border = '1px solid #E1E1DA';

        var size = document.createElement('span');
        size.innerHTML = 'Size';
        size.style.padding = '6px';
        sizeContainer.appendChild(size);

        var select = document.createElement('select');
        select.className = 'bs__select';
        select.name = 'id';
        select.style.border = '0';
        select.style.maxWidth = '42px';
        select.style.backgroundColor = 'white';
        product.variants.forEach(function(variant) {
            var option = document.createElement('option');
            option.className = 'bs__option';
            option.style.fontSize = '10px';
            option.value = variant.id;
            option.textContent = variant.title;
            select.appendChild(option);
        });
        sizeContainer.appendChild(select);

        // containerBottom.appendChild(sizeContainer);

        var submitButton = document.createElement('input');
        submitButton.type = 'submit';
        submitButton.className = 'bs__buttonClass';
        submitButton.style.background = 'black';
        submitButton.style.color = 'white';
        submitButton.style.border = 'none';
        submitButton.style.fontSize = '0.7rem';
        submitButton.style.padding = '2px 27px';
        submitButton.style.fontFamily = 'Century Gothic';
        submitButton.value = 'Add';
        containerBottom.appendChild(submitButton);

        infoContainer.appendChild(containerBottom);
        form.appendChild(infoContainer);

        // Append the form to the addToCartForm
        addToCartForm.appendChild(form);

        form.addEventListener('submit', function(event) {
            event.preventDefault();
            event.stopPropagation();

            // Disable the submit button to prevent multiple submissions
            submitButton.disabled = true;

            // Create a FormData object to send form data
            var formData = new FormData(form);

            // Extract necessary data from FormData
            var variantId = formData.get('id');
            var quantity = formData.get('quantity') || 1; // Default to 1 if not specified

            // Debugging: Check what FormData is holding
            console.log("FormData", formData);

            // Prepare the data payload for the Shopify API request
            var payload = {
                id: variantId,
                quantity: quantity,
                // sections: cartDrawer.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
            };

            console.log("Payload to send:", payload);

            // Send the form data using fetch API
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Shopify should return JSON
            })
            .then(data => {
                sendCartMessageToSlack();
                console.log('Item added:', data);   
                if (!window.location.search.includes('opencart=true')) {
               // Add 'opencart=true' to the URL if it's not already there
               window.location = window.location.href + '?opencart=true';
               } else {
              // Remove 'opencart=true' from the URL
              var url = new URL(window.location.href);
              url.searchParams.delete('opencart');
              window.location = url.toString() + '?opencart=true';
              }

            })
            .catch(error => {
                console.error('Error:', error);
            })
            .finally(() => {
                // Re-enable the submit button
                submitButton.disabled = false;
            });
        });

    } else {
        console.error("Product or its variants not found.");
    }
}

function formatMoney(cents, currency, locale = 'en') {
  if (isNaN(cents) || cents === null) {
    return '0.00';
  }
  const amount = cents / 100;
  return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
}
       


// Function to fetch a product by its handle
function fetchProduct(productHandle, elementId) {
    fetch(`/products/${productHandle}.js`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(product => {
            createAddToCartForm(elementId, product);
        })
        .catch(error => {
            console.error('Error fetching product:', error);
        });
}

// Function to fetch cart items and determine recommendations
function fetchCartItems() {
    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(cartdata => {
        const keys = Object.keys(ProdCollections);
  
        const randomKeyIndex = Math.floor(Math.random() * keys.length); 
        const randomKey = keys[randomKeyIndex];
        const top = ProdCollections[randomKey].tops;
        const bottom = ProdCollections[randomKey].bottoms;
        let inCartBottoms = false;
        let inCartBikini = false;
        let hardcodedtop = false;
        let hardcodedbottom = false;
        let currentabove = '';
        let currentbelow = '';

        cartdata.items.forEach(item => {
          for (const key in ProdCollections) {
                const collection = ProdCollections[key];
                 const above = collection.tops;
                const below = collection.bottoms;
        if (item.handle === above.handle) {
            inCartBikini = true;
             currentabove = below.handle;
        }
        if (item.handle === below.handle) {
             inCartBottoms = true;
              currentbelow = above.handle;
        
        }
          }
        if(item.handle === 'facify-beauty-wand-facify') {
             hardcodedtop = true;
        }
        if (item.handle === 'the-body-travel-pouche-for-all-skin-types'){
             hardcodedbottom = true;
        }
    });


    if (inCartBikini && inCartBottoms) {
         if (hardcodedtop && hardcodedbottom) {
               console.log('all added');
               const bscontainer = document.getElementById("best-sellers-container");
               bscontainer.style.display = 'none';
             
         }
         else if (hardcodedtop) {
                    fetchProduct('the-body-travel-pouche-for-all-skin-types', 'form2');
         }
          else if (hardcodedbottom) 
         {
                    fetchProduct('facify-beauty-wand-facify', 'form1');
         }
         else{
                fetchProduct('facify-beauty-wand-facify', 'form1');
                fetchProduct('the-body-travel-pouche-for-all-skin-types', 'form2');
         }
    facify-beauty-wand-facify
    }
    else if (inCartBikini) {
         if (hardcodedtop && hardcodedbottom) {
               fetchProduct(currentabove, 'form2');
         } 
         else if (hardcodedtop) {
            fetchProduct('the-body-travel-pouche-for-all-skin-types', 'form2');
            fetchProduct(currentabove, 'form1');
          }
          else {
          fetchProduct('facify-beauty-wand-facify', 'form2');
          fetchProduct(currentabove, 'form1');
          }
     } else if (inCartBottoms) {
         if (hardcodedtop && hardcodedbottom) {
               fetchProduct(currentbelow, 'form1');
         }
         else  if (hardcodedbottom) {
             fetchProduct(currentbelow, 'form1');
             fetchProduct('facify-beauty-wand-facify', 'form2');  
           }  
          else{
            fetchProduct(currentbelow, 'form1');
           fetchProduct('the-body-travel-pouche-for-all-skin-types', 'form2');
          }
    } else {
          fetchProduct(top.handle, 'form1'); 
         fetchProduct(bottom.handle, 'form2');
   }

  
    })
    .catch(error => console.error('Error:', error));
}     